import { z } from 'zod';

import { FEATURE_FLAG } from '~/constants/featureFlags';

import { type RouteExportParams } from '~/types/router.type';

export const validateSearch = z.object({
  invoiceCheckIgnoredArticleId: z.uuid().optional(),
});

export const routeParams: RouteExportParams = {
  permissions: ['org_unit.'],
  vestigasSupportAccess: true,
  disablingFeatureFlag: FEATURE_FLAG.DISABLE_INVOICES,
};
